<template>
    <div>
        <div id="msg-div"></div>
        <div>
            <p>
                {{ $t('label.shaparak_request_list') }}
            </p>
        </div>
        <kt-row>
            <kt-col v-if="shaparak_requests.length > 0">
                <kt-table is_responsive class="shRequestTable">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>{{ $t('label.status') }}</th>
                        <th>{{ $t('label.type') }}</th>
                        <th>{{ $t('label.response_thacking_number') }}</th>
                        <th>{{ $t('label.response_success') }}</th>
                        <th>{{ $t('label.request_date') }}</th>
                        <th>{{ $t('label.response_rejection_reason') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-bind:key="index" v-for="(request, index) in shaparak_requests">
                        <td>{{ request.id }}</td>
                        <td>{{ shRequestStatusStr.get(request.status) }}</td>
                        <!-- <td>{{ shRequestTypeStr.get(request.type) }}</td> -->
                        <td>{{ request.type }}</td>
                        <td>{{ request.response_tracking_number ? request.response_tracking_number : '-' }}</td>
                        <td>{{ shSuccessRequest(request.response_success) }}</td>
                        <td>{{request.request_date}}</td>
                        <td v-bind:key="rindex"
                            v-for="(rejection, rindex) in request.response_rejection_reason">
                            <span>{{ rejection.codeExceptionValue }} : {{ rejection.fieldName }}</span>
                        </td>
                        <td v-if="request.response_rejection_reason == null"></td>
                    </tr>
                    </tbody>
                </kt-table>
            </kt-col>
            <kt-col v-else class="mb-4">
                <p class="badge badge-warning w-100 p-3 text-dark" style="font-size:1.2em">
                    {{ $t('not_sent_request_to_shaparak_yet') }}
                </p>
            </kt-col>
        </kt-row>
        <kt-row>
            <kt-col>
                <kt-form-action class="mb-4">
                    <button
                            class="btn btn-md btn-success btn-wide"
                            type="button"
                            id="resend_submit_btn"
                            @click="sendNewTerminalRequest"
                    >
                        {{ $t('btn.submit_again') }}
                    </button>
                </kt-form-action>
            </kt-col>
        </kt-row>
        <hr>
        <kt-row>
            <kt-col>
                <shaparak-requests
                        :form_data="form_data"
                        :addresses="addresses"
                        :sheba_numbers="sheba_numbers">
                </shaparak-requests>
            </kt-col>
        </kt-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { shRequestStatusStr } from '@/constants/shaparakRequestStatus'
import { shRequestTypeStr } from '@/constants/shaparakRequestType'
import $ from "jquery";
import { shaparakService } from '@/common/api.service'
import shaparakRequests from "./shaparak-requests";
import { KTApp } from '@/plugins/core/app'

export default {
    computed: {
        ...mapGetters('shaparak', [
            'shaparak_requests'
        ]),
        shRequestStatusStr() {
            return shRequestStatusStr
        },
    },
    components: {
        shaparakRequests
    },
    props: {
        form_data: {
            required: true,
        },
        addresses: {
            required: true,
        },
        sheba_numbers: {
            required: true
        }
    },
    mounted() {
        this.$store.dispatch('shaparak/fetchShaparakRequests',this.$route.params.hashid)
    },
    methods: {
        shSuccessRequest(response_success) {
            return response_success == 1 ? this.$t('label.yes') : this.$t('label.no')
        },
        sendNewTerminalRequest(e) {
            let hashid = this.$route.params.hashid
            let btn = $('#resend_submit_btn');
            KTApp.progress(btn)
            shaparakService.resendNewTerminalRequest(hashid).then(response => {
                this.showMsg($('#msg-div'), 'success', response.data.message)
                this.$store.dispatch('shaparak/fetchShaparakRequests',this.$route.params.hashid)
                KTApp.unprogress(btn)
            }).catch(({response}) => {
                this.showMsg($('#msg-div'), 'danger', response.data.message)
                KTApp.unprogress(btn)
            })
        }
    }
}
</script>

<style>
.shRequestTable th, td{
    text-align: center;
}
</style>